<template>
  <div class="mb-3">
    <label :for="inputID" class="form-label">{{ label }}</label>
    <input
      @change="update"
      autocomplete="one-time-code"
      :required="required"
      type="text"
      class="form-control"
      v-model="value"
      :maxlength="maxLength"
      :minlength="minLength"
      :id="inputID"
      :disabled="isDisabled"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TextInputComponent",
  components: {},

  data() {
    return {
      value: "",
    };
  },

  methods: {
    update(event: Event) {
      console.log(event);
      this.$emit("onUpdate", this.inputID, this.value);
    },
  },

  setup(props) {
    console.log(props);
  },

  props: {
    required: {
      type: Boolean,
    },
    maxLength: {
      type: Number,
    },
    minLength: {
      type: Number,
    },
    label: {
      type: String,
    },
    inputID: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
    },
  },

  emits: ["onUpdate"],
});
</script>

<style scoped>
input {
  min-width: 300px;
}
</style>
